import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Input, Radio } from "antd";
import "./style.scss";
import logo from "assets/cemlogo.png";
import { useDispatch } from "react-redux";
import { setLogin, setUser } from "state";
import { IForm, ILoginRequestData } from "types";
import Swal from "sweetalert2";
import { api } from "services/api";

export const LoginPage = () => {
	const [canGo, setCanGo] = useState(false);
	const [loading, setLoading] = useState(false);
	const [validatingToken, setValidatingToken] = useState(false);
	const [type, setType] = useState<string>("student");
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const submitFormData = (values: IForm) => {
		const { email, password } = values;
		const loginData = { email, password, type_auth: "email", section: type };
		handleLogin(loginData);
	}

	const handleLogin = useCallback((data: ILoginRequestData) => {
		setLoading(true);

		api
			.post("/login", data)
			.then((result) => {
				const {
					data: {
						data: { token, user, section },
					},
				} = result;

				const { id, username, person, email } = user;

				setLoading(false);

				localStorage.setItem(
					"token",
					JSON.stringify({
						token,
						person,
						user,
						id,
						username,
						email,
						label: section,
					})
				);

				dispatch(
					setLogin({
						email,
						name: person?.name,
						label: section,
						isAuthenticated: token !== undefined,
					})
				);

				dispatch(
					setUser({
						email,
						name: person?.name,
						label: section,
						id,
						username,
					})
				);

				navigate("/dash");
			})
			.catch((err) => {
				const status = err?.response?.status;
				const { feedback } = err?.response?.data;
				setLoading(false);
				if (
					status === 400 ||
					status === 404 ||
					status === 403 ||
					status === 401
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	}, []);

	useEffect(()=> {
		const url = new URL(window.location.href);
		setValidatingToken(false)

		if (url.searchParams.has('token')) {
			setValidatingToken(true)
			const url = window.location.href;
			const regex = /[?&]token=%22([^&]*)%22/; // Regex para pegar o parâmetro "token"
			const match = url.match(regex);
			if(!match) {
				return;
			}
			handleLogin({ token: match[1]});
		}

		setValidatingToken(false)

		return
	}, [handleLogin]);

	return (
		<div className="login">
			<div className="login__container">
				<div className="login__container__header">
					<img src={logo} alt="logo" />
				</div>
				<div className="login__container__title">
					<h1>Acessar a plataforma</h1>
				</div>
				{
					validatingToken ? (
						<div className="login__container__form">
							<div className="loading">
							<h3>Estamos validando seu acesso...</h3>
							</div>
						</div>

					) : (
						
						<div className="login__container__form">
							<Form
								name="basic"
								onFinish={(values) => submitFormData(values)}
								onFinishFailed={(error) => console.log(error)}
								autoComplete="off"
							>
								<div className="login__container__form__type">
									<Radio.Group
										onChange={(e) => setType(e.target.value)}
										defaultValue={"student"}
									>
										<Radio value={"student"}>Estudante</Radio>
										<Radio value={"manager"}>Gestor</Radio>
									</Radio.Group>
								</div>
								<Form.Item
									name={"email"}
									rules={[
										{
											required: true,
											message: "E-mail necessário",
										},
									]}
								>
									<Input
										placeholder={"E-mail"}
										id="userinfo"
										onChange={(e) =>
											setCanGo(
												e.target.value !== "" &&
													e.target.value.includes("@") &&
													// @ts-ignore
													document.getElementById("basic_password").value !== ""
											)
										}
									/>
								</Form.Item>

								<Form.Item
									name="password"
									rules={[{ required: true, message: "Senha necessária" }]}
								>
									<Input.Password
										placeholder="Senha"
										onChange={(e) =>
											setCanGo(
												e.target.value !== "" &&
													// @ts-ignore
													document.getElementById("userinfo").value !== "" &&
													// @ts-ignore
													document.getElementById("userinfo").value.includes("@")
											)
										}
									/>
								</Form.Item>

								<Form.Item>
									<Button
										loading={loading}
										type="primary"
										htmlType="submit"
										disabled={!canGo}
									>
										Entrar
									</Button>
								</Form.Item>
							</Form>
							<div className="login__container__forget">
								<Link to={"/recover-password"}>Esqueci minha senha</Link>
							</div>
							<hr />
							<div className="login__container__footer">
								<Link to={"/signup"}>Criar nova conta</Link>
							</div>
						</div>
					)
				}

			</div>
		</div>
	);
};
